import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fluid/buttons';
import { FormLayoutFieldContainer } from '@fluid/layouts';
import { getDataAttributes, getLocaleText } from '../utils/LoginUtils';

const LoginLinks = (props) => {
    const {
        contextCls,
        loginConfig,
        legacyLoginConfig,
        isInteractive,
        onLinkSelect,
        locale,
    } = props;

    const { fiArsRegistrationEnabled } = legacyLoginConfig ?? {};
    const { links = [] } = loginConfig ?? {};
    const filteredLinks = (links || []).filter((item) => {
        return fiArsRegistrationEnabled
            ? item && item.propertyName !== 'registerLinkLabel'
            : true;
    });

    if (!filteredLinks.length) {
        return false;
    }

    const handleClick = ({ data }) => {
        if (isInteractive && onLinkSelect) {
            onLinkSelect(data);
        }
    };

    const linkElements = filteredLinks.map((item, index) => {
        const { dataAttributes = {}, propertyName } = item;
        const { label = {} } = item;
        const displayText = getLocaleText(label, locale);

        const linkProps = {
            data: { item, index },
            ...getDataAttributes(dataAttributes),
        };

        if (!isInteractive) {
            linkProps.tabIndex = '-1';
            linkProps.isDisabled = true;
        }

        let id = '';

        if (propertyName === 'browserCompatibilityLinkLabel') {
            id = 'test-browser';
        } else if (propertyName === 'troubleTestingLinkTestLabel') {
            id = 'trouble-test-browser';
        }

        return (
            <li key={propertyName}>
                <Button
                    id={id}
                    onClick={handleClick}
                    isLink
                    isDisabled
                    {...linkProps}
                >
                    {displayText}
                </Button>
            </li>
        );
    });

    return (
        <FormLayoutFieldContainer>
            <nav>
                <ul className={contextCls}>{linkElements}</ul>
            </nav>
        </FormLayoutFieldContainer>
    );
};

LoginLinks.defaultProps = {};

LoginLinks.propTypes = {
    contextCls: PropTypes.string,
    locale: PropTypes.string.isRequired,
    loginConfig: PropTypes.object.isRequired,
    isInteractive: PropTypes.bool,
    onLinkSelect: PropTypes.func,
    legacyLoginConfig: PropTypes.object,
};

export default LoginLinks;
